import { render, staticRenderFns } from "./ViberCampaignDetails.vue?vue&type=template&id=64c5d212&scoped=true&"
import script from "./ViberCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignDetails.vue?vue&type=style&index=0&id=64c5d212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5d212",
  null
  
)

export default component.exports